import { TopicCardTimeEntry as ServerTopicCardTimeEntry } from 'server/models/TopicCardTimeEntry';

export { TopicCardTimeEntryData, TopicCardTimeEntryOptions } from 'server/models/TopicCardTimeEntry';

export class TopicCardTimeEntry extends ServerTopicCardTimeEntry {
    EffectiveLabel() {
        return this.Label() || 'Time';
    }
}


// WEBPACK FOOTER //
// ./data/models/TopicCardTimeEntry.ts